import {UserCard} from "./component/user_card/UserCard";
import {UsersGrid} from "./component/user_grid/UsersGrid";
import {UsersController} from "./route/UsersController";
import UsersModuleConfiguration from "./UsersModuleConfiguration";
import {AccessLevelToggleComponent} from "./component/access_level_toggle/access-level-toggle.component";
import {AccessLevelGridComponent} from "./component/access-level-grid/access-level-grid.component";
import {AccessLevelPickerComponent} from "./component/access_level_picker/access-level-picker.component";
import {UserSubscriptionListComponent} from "./component/user_subscriptions_list/user-subscription-list.component";
import {UserSubscriptionComponent} from "./component/user_subscriptions/user-subscription.component";
import {AccessLevelPresetPicker} from "./component/access-level-preset-picker/access-level-preset-picker";
import {USERS_CONTROLLER_NAME} from "../utils/names/controllerNames";
import {AccordionUserSubscriptionComponent} from "./dialog/new_user/accordion/accordion.user.subscription.component";

UsersModuleConfiguration
    .createNewModule()
    .controller(USERS_CONTROLLER_NAME, UsersController.instance)
    .component('accessLevelPicker', AccessLevelPickerComponent.instance)
    .component('accessLevelToggle', AccessLevelToggleComponent.instance)
    .component('accessLevelGrid', AccessLevelGridComponent.instance)
    .component('accessLevelPresetPicker', AccessLevelPresetPicker.instance)
    .component("userCard", UserCard.instance)
    .component('usersGrid', UsersGrid.instance)
    .component('userSubscriptionList', UserSubscriptionListComponent.instance)
    .component('userSubscription', UserSubscriptionComponent.instance)
    .component('accordionUserSubscription', AccordionUserSubscriptionComponent.instance);
